// frontend/src/App.js

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useContext } from "react";
import { Context } from "./context/Context";
import { Navigate } from "react-router-dom";
import TopBar from "./components/topbar/TopBar";
import Footer from "./components/footer/Footer";
import Articles from "./pages/articles/Articles";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import Profile from "./pages/profile/Profile";
import Referrals from "./pages/referrals/Referrals";
import Affiliates from "./pages/affiliates/Affiliates";
import Write from "./pages/write/Write";
import Edit from "./pages/edit/Edit";
import Admin from "./pages/admin/Admin";
import Settings from "./pages/settings/Settings";
import Reading from "./pages/reading/Reading";
import Search from "./pages/search/Search";
import Trending from "./pages/trending/Trending";
import Subscribe from "./pages/subscribe/Subscribe";
import Preference from "./pages/preference/Preference";
import Followers from "./pages/followers/Followers";
import Followings from "./pages/followings/Followings";
import Username from "./pages/username/Username";
import Post from "./pages/post/Post";
import PreviewArticle from "./pages/previewArticle/PreviewArticle";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import AffiliateProgram from "./pages/affiliateProgram/AffiliateProgram";
import Partnerships from "./pages/partnerships/Partnerships";
import AffiliateProgramThankYou from "./pages/affiliateProgramThankYou/AffiliateProgramThankYou";
import PartnershipsThankYou from "./pages/partnershipsThankYou/PartnershipsThankYou";
import LegalPage from "./pages/legalPage/LegalPage";
import StyleGuide from "./pages/styleGuide/StyleGuide";

import { ToastContainer } from "react-toastify";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/header/Header";

import Authors from "./pages/authors/Authors";
import Categories from "./pages/categories/Categories";
import Author from "./pages/author/Author";
import Category from "./pages/category/Category";
import Faq from "./pages/faq/Faq";

function App() {
  const { user } = useContext(Context);
  return (
    <Router>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <>
              <Home />
              <Footer />
            </>
          }
        />
        <Route
          path="/articles"
          element={
            <>
              <Header />
              <Articles />
              <Footer />
            </>
          }
        />
        <Route
          path="/subscribe"
          element={
            <>
              <Subscribe />
              <Footer />{" "}
            </>
          }
        />
        <Route
          path="/preference"
          element={
            <>
              <Preference />
              <Footer />
            </>
          }
        />
        <Route
          path="/register"
          element={
            <>
              <Register />
              <Footer />
            </>
          }
        />
        <Route
          path="/login"
          element={
            <>
              <Login />
              <Footer />
            </>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <>
              <ForgotPassword />
              <Footer />
            </>
          }
        />
        <Route
          path="/username"
          element={
            <>
              <Username />
              <Footer />
            </>
          }
        />
        <Route
          path="/faq"
          element={
            <Navigate to="/" replace />
          }
        />
        <Route
          path="/search"
          element={
            <>
              <Header />
              <Search />
              <Footer />
            </>
          }
        />
        <Route
          path="/write"
          element={
            // user ? (
            <>
              <Header />
              <Write />
              <Footer />
            </>
            // ) : (
            //   <>
            //     <Register />
            //     <Footer />
            //   </>
            // )
          }
        />
        <Route
          path="/edit"
          element={
            user ? (
              <>
                <Header />
                <Edit />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/admin"
          element={
            user ? (
              <>
                <Header />
                <Admin />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/settings"
          element={
            user ? (
              <>
                <Header />
                <Settings />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/profile"
          element={
            user ? (
              <>
                <Header />
                <Profile />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/referrals"
          element={
            user ? (
              <>
                <Header />
                <Referrals />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/affiliates"
          element={
            user ? (
              <>
                <Header />
                <Affiliates />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/reading"
          element={
            user ? (
              <>
                <Header />
                <Reading />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/followings"
          element={
            user ? (
              <>
                <Header />
                <Followings />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/followers"
          element={
            user ? (
              <>
                <Header />
                <Followers />
                <Footer />
              </>
            ) : (
              <>
                <Register />
                <Footer />
              </>
            )
          }
        />
        <Route
          path="/:postSlug"
          element={
            <>
              <Header />
              <Post />
              <Footer />
            </>
          }
        />
        <Route
          path="/preview/:postSlug"
          element={
            <>
              <Header />
              <PreviewArticle />
              <Footer />
            </>
          }
        />
        <Route
          path="/author/:authorId" //Clickable author carousel on Homepage.
          element={
            <>
              <Header />
              <Author />
              <Footer />
            </>
          }
        />
        <Route
          path="/trending"
          element={
            <>
              <Header />
              <Trending />
              <Footer />
            </>
          }
        />
        <Route
          path="/authors"
          element={
            <>
              <Header />
              <Authors />
              <Footer />
            </>
          }
        />
        <Route
          path="/categories"
          element={
            <>
              <Header />
              <Categories />
              <Footer />
            </>
          }
        />
        <Route                        //Clickable article carousel on Homepage.
          path="/:postSlug"
          element={
            <>
              <Header />
              <Post />
              <Footer />
            </>
          }
        />
        <Route                        //Clickable category carousel on Homepage.
          path="/category/:catId"
          element={
            <>
              <Category />
              <Footer />
            </>
          }
        />
        <Route                        //Clickable author carousel on Homepage.
          path="/author/:authorId"
          element={
            <>
              <Header />
              <Author />
              <Footer />
            </>
          }
        />
        <Route
          path="/category/:catId"
          element={
            <>
              {/* <Header /> */}
              <Category />
              <Footer />
            </>
          }
        />
        <Route
          path="/affiliate-program"
          element={
            <>
              <Header />
              <AffiliateProgram />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/partnerships"
          element={
            <>
              <Header />
              <Partnerships />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/affiliate-program-thank-you"
          element={
            <>
              <Header />
              <AffiliateProgramThankYou />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/partnerships-thank-you"
          element={
            <>
              <Header />
              <PartnershipsThankYou />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/style-guide"
          element={
            <>
              <Header />
              <StyleGuide />
              <Footer />
            </>
          }
        />
        <Route
          path="/tos"
          element={
            <>
              <LegalPage fileName="TermsofService.html" /> <Footer />
            </>
          }
        ></Route>
        <Route
          path="/privacyPolicy"
          element={
            <>
              <LegalPage fileName="PrivacyPolicy.html" /> <Footer />
            </>
          }
        ></Route>
        <Route
          path="/cookiePolicy"
          element={
            <>
              <LegalPage fileName="CookiePolicy.html" /> <Footer />
            </>
          }
        ></Route>
        <Route
          path="/codeofConduct"
          element={
            <>
              <LegalPage fileName="CodeofConduct.html" /> <Footer />
            </>
          }
        ></Route>
        <Route
          path="/generalDisclaimer"
          element={
            <>
              <LegalPage fileName="GeneralDisclaimer.html" /> <Footer />
            </>
          }
        ></Route>
      </Routes>
      {/* <Footer /> */}
      <ToastContainer />
    </Router>
  );
}

export default App;
